// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__UR2s9","content":"styles_content__NN6KI","title":"styles_title__HcYoR"};